import { featureEach } from '@turf/meta';
import { fromUrl } from 'geotiff';
import proj4 from 'proj4';

// todo: fetch from server
proj4.defs('EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs +type=crs');
proj4.defs(
  'EPSG:23700',
  '+proj=somerc +lat_0=47.1443937222222 +lon_0=19.0485717777778 +k_0=0.99993 +x_0=650000 +y_0=200000 +ellps=GRS67 +towgs84=52.17,-71.82,-14.9,0,0,0,0 +units=m +no_defs +type=crs',
);
proj4.defs(
  'EPSG:3414',
  '+proj=tmerc +lat_0=1.36666666666667 +lon_0=103.833333333333 +k=1 +x_0=28001.642 +y_0=38744.572 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs',
);
proj4.defs(
  'EPSG:3346',
  '+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs',
);
proj4.defs(
  'EPSG:27700',
  '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +nadgrids=uk_os_OSTN15_NTv2_OSGBtoETRS.tif +units=m +no_defs +type=crs',
);
proj4.defs(
  'EPSG:23700',
  '+proj=somerc +lat_0=47.1443937222222 +lon_0=19.0485717777778 +k_0=0.99993 +x_0=650000 +y_0=200000 +ellps=GRS67 +towgs84=52.17,-71.82,-14.9,0,0,0,0 +units=m +no_defs +type=crs',
);
proj4.defs(
  'EPSG:5513',
  '+proj=krovak +axis=swu +lat_0=49.5 +lon_0=24.8333333333333 +alpha=30.2881397527778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +units=m +no_defs +type=crs',
);

proj4.defs('EPSG:25832', '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs');

const promise = fromUrl('/uk_os_OSTN15_NTv2_OSGBtoETRS.tif').then(
  (tiff) => proj4.nadgrid('uk_os_OSTN15_NTv2_OSGBtoETRS.tif', tiff).ready,
);

export const reprojectGeoJSON = async (geojson: any, from = 'EPSG:27700', to = 'EPSG:4326') => {
  await promise;

  geojson = JSON.parse(JSON.stringify(geojson));

  featureEach(geojson, (feature) => {
    feature.geometry.coordinates = traverseAndProject(feature.geometry.coordinates, from, to);
  });
  return geojson;
};

export const project = async (coords: any, from = 'EPSG:27700', to = 'EPSG:4326') => {
  await promise;

  if (typeof coords[0] === 'number') {
    return proj4(from, to, coords);
  }
  return coords.map((c) => project(c));
};

export const traverseAndProject = (coords: any, from: string, to: string) => {
  if (typeof coords[0] === 'number') {
    return proj4(from, to, coords);
  }
  return coords.map((c) => traverseAndProject(c, from, to));
};
